import React, { useEffect, useState, useContext, useRef } from 'react'
import openSocket from 'socket.io-client'
//import { socket } from '../../../common/socket'
import { Button, Drawer } from '@material-ui/core'
import MenuItem from '@material-ui/core/MenuItem'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import BiddingItem from '../../../components/molecules/Bidding/BiddingItem'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { Pagination } from '@material-ui/lab'
import Box from '@material-ui/core/Box'
import { useHistory } from 'react-router-dom'
import CustomSelect from '../../../components/atoms/Inputs/CustomSelect'
import SecondaryButton from '../../../components/atoms/SecondaryButton'
import FavoriteCheckbox from '../../../components/atoms/FavoriteCheckbox'
import PrimaryButton from '../../../components/atoms/PrimaryButton'
import LineItemDetails from './LineItemDetails'
import Timer from '../../../common/timer'
import Popup from '../../../components/organisms/Popup'
import CurrencyConverter from '../CurrencyConverter'
import { apiCall } from '../../../common/api'
import { dateFormatFront } from '../../../common/components'
import { lineItemBidSocketHandler } from '../../Common/socketHandler'
import ReactHtmlParser from 'react-html-parser'
// context
import CommonContext from '../../../context/common/commonContext'
import AuthContext from '../../../context/auth/authContext'
import AlertContext from '../../../context/alert/alertContext'
import Loader from '../../../components/molecules/Loader'

function TabPanel(props) {
    const { children, value, index, html, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {html ? (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: html,
                            }}
                        ></span>
                    ) : (
                        <span>{children}</span>
                    )}
                </Box>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    fullList: {
        width: 'auto',
    },
}))

const LineItemAuction = ({ images, product, downloadFile, setProduct }) => {
    const alertContext = useContext(AlertContext)
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const { setAlert } = alertContext
    const { phrase } = useContext(CommonContext)
    const [value, setValue] = useState(0)
    const [lineItems, setLineItems] = useState([])
    const [lineItemsView, setLineItemsView] = useState([])
    const [totalProductCnt, setTotalProductCnt] = useState(0)
    const [totalPageCnt, setTotalPageCnt] = useState(0)
    const [pageDescription, setPageDescription] = useState(0)
    const [pageNum, setPageNum] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [lineItemsReady, setLineItemsReady] = useState(false)
    const [bidInstructionOpen, setBidInstructionOpen] = useState(false)
    const [bulkBidLineItems, setBulkBidLineItems] = useState([])
    const [bulkBidTable, setBulkBidTable] = useState([])
    const [bulkBidPopupOpen, setBulkBidPopupOpen] = useState(false)
    const [showDwBidStatus, setDwBidStatus] = useState(product.dwBidStatus) // download bid status link
    const [contactPopup, setContactPopup] = useState(false)
    const [productDescPopup, setProductDescPopup] = useState(false)
    const [zoomOpen, setZoomOpen] = useState(false)
    const [zoomImageIndex, setZoomImageIndex] = useState(0)
    const [isFullscreen, setIsFullscreen] = useState(false)
    const useImageZoom = () => {
        const [zoom, setZoom] = useState(1)
        const [position, setPosition] = useState({ x: 0, y: 0 })
        const [isDragging, setIsDragging] = useState(false)
        const dragStart = useRef({ x: 0, y: 0 })
        const lastZoom = useRef(1)

        const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

        const handleWheel = (e) => {
            e.preventDefault()
            const delta = e.deltaY < 0 ? 1.12 : 0.89
            let newZoom = zoom * delta
            newZoom = clamp(newZoom, 1, 9)

            if (newZoom <= 1.01) {
                newZoom = 1
                setPosition({ x: 0, y: 0 })
            } else {
                setPosition((prev) => ({
                    x: prev.x * (newZoom / zoom),
                    y: prev.y * (newZoom / zoom),
                }))
            }

            lastZoom.current = newZoom
            setZoom(newZoom)
        }

        const handleMouseDown = (e) => {
            if (zoom <= 1) return
            e.preventDefault()
            setIsDragging(true)
            dragStart.current = { x: e.clientX - position.x, y: e.clientY - position.y }
        }

        const handleMouseMove = (e) => {
            if (!isDragging) return

            const maxX = ((zoom - 1) * window.innerWidth) / 2
            const maxY = ((zoom - 1) * window.innerHeight) / 2
            const newX = clamp(e.clientX - dragStart.current.x, -maxX, maxX)
            const newY = clamp(e.clientY - dragStart.current.y, -maxY, maxY)

            setPosition({ x: newX, y: newY })
        }

        const handleMouseUp = () => setIsDragging(false)

        const reset = () => {
            setZoom(1)
            setPosition({ x: 0, y: 0 })
            setIsDragging(false)
            lastZoom.current = 1
        }

        return {
            zoom,
            position,
            isDragging,
            handleWheel,
            handleMouseDown,
            handleMouseMove,
            handleMouseUp,
            reset,
        }
    }

    const zoom = useImageZoom()
    useEffect(() => {
        if (zoomOpen) {
            document.body.style.overflow = 'hidden'
            document.body.style.touchAction = 'none'
        } else {
            document.body.style.overflow = ''
            document.body.style.touchAction = ''
        }

        const handleKey = (e) => {
            if (!zoomOpen) return
            if (e.key === 'ArrowLeft') {
                setZoomImageIndex((i) => (i === 0 ? images.length - 1 : i - 1))
                zoom.reset()
            }
            if (e.key === 'ArrowRight') {
                setZoomImageIndex((i) => (i === images.length - 1 ? 0 : i + 1))
                zoom.reset()
            }
            if (e.key === 'Escape') {
                setZoomOpen(false)
                zoom.reset()
            }
        }

        window.addEventListener('keydown', handleKey)
        return () => {
            document.body.style.overflow = ''
            document.body.style.touchAction = ''
            window.removeEventListener('keydown', handleKey)
        }
    }, [zoomOpen, images.length])

    const toggleFullscreen = (e) => {
        if (e) e.stopPropagation()

        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen?.()
        } else {
            document.exitFullscreen?.()
        }
    }

    // Listen for fullscreen changes
    useEffect(() => {
        const handler = () => setIsFullscreen(Boolean(document.fullscreenElement))
        document.addEventListener('fullscreenchange', handler)
        return () => document.removeEventListener('fullscreenchange', handler)
    }, [])

    const firstLineItemLoad = useRef(true)
    const bulkBidRef = useRef({}) // store info needed for bulk bidding
    const didBulkBid = useRef(false)

    let history = useHistory()
    const [state, setState] = useState({
        right: false,
        bottom: false,
        data: {},
    })
    // change results per page value
    const changePageLimit = (e) => {
        setLineItemsReady(false)
        setPageLimit(e.target.value)
        setPageNum(1)
    }
    const changePageHandler = (e, value) => {
        setLineItemsReady(false)
        setPageNum(value)
    }
    const getLineItemProducts = () => {
        let endPoint = `getLineItemsProduct${isAuthenticated ? '' : '_new'}?ajax=1&sh_limit=${
            pageLimitRef.current
        }&page=${pageNumRef.current}&project_id=${product.id}`
        apiCall('get', endPoint, '', '', 'product').then((res) => {
            console.log('[LineItemAuction] ', res)
            if (res.data.status == 'success') {
                let lineItemsTemp = []
                if (res.data.data.subproject.length == 0) {
                    lineItemsTemp.push(
                        <tr>
                            <td colSpan="5" className="text-center">
                                No line items available
                            </td>
                        </tr>,
                    )
                } else {
                    setTotalProductCnt(res.data.data.total_pagecnt)
                    setPageDescription(res.data.data.set_disp)
                    let partNumbers = {}
                    for (var i of product.linedata) {
                        partNumbers[i.id] = i.part_number
                    }

                    lineItemsTemp = res.data.data.subproject.map((item) => {
                        let companyHasBid = 0
                        if (user.companyid && user.companyid != '' && user.companyid != '0') {
                            companyHasBid = item.companynot
                        }

                        return {
                            id: item.id,
                            category_id: item.category_id,
                            title: item.title,
                            description: item.description,
                            qty: item.qty,
                            currency: item.currency,
                            currency_symbol: item.currency_symbol,
                            wpriceview: item.wpriceview,
                            wprice: item.wprice,
                            rprice: item.rprice,
                            next_bid: item.next_bid,
                            bidtopstatus: item.bidtopstatus, // status column, status of user's bid
                            bidPrice: item.bidderproxyant,
                            market_status: product.market_status,
                            master_id: product.id,
                            auctiontype: product.auctiontype,
                            bidtype: item.bidtype,
                            lottype: item.lottype,
                            csvfile: product.csvfile,
                            incrementAmt: item.incrementamt,
                            partNumber: partNumbers[item.id],
                            hasBid: item.cbidnot,
                            companyHasBid: companyHasBid,
                            isSocketUpdate: false,
                        }
                    })
                }

                setLineItems(lineItemsTemp)
            }
        })
    }

    // download buyer's bid status
    const downloadBidStatus = () => {
        apiCall('get', `downloadBidStatus/${product.id}`, '', '', 'product').then((res) => {
            console.log('downloaded bid status: ', res)
            window.location.href = res.data.filePath
        })
    }

    const lineItemsRef = useRef(lineItems) // line items on the page
    const bulkBidLineItemsRef = useRef(bulkBidLineItems)
    const userRef = useRef(user)
    const pageNumRef = useRef(pageNum)
    const pageLimitRef = useRef(pageLimit)
    useEffect(() => {
        bulkBidLineItemsRef.current = bulkBidLineItems
        userRef.current = user
        lineItemsRef.current = lineItems
        pageNumRef.current = pageNum
        pageLimitRef.current = pageLimit
    })

    const socketHandler = (data, type) => {
        lineItemBidSocketHandler(
            data,
            type,
            userRef.current,
            lineItemsRef.current,
            bulkBidLineItemsRef.current,
            didBulkBid.current,
            setLineItems,
            setDwBidStatus,
            setBulkBidLineItems,
            setAlert,
            phrase,
        )
    }

    const cancelBidHandler = (data) => {
        let isLineOnScreen = lineItemsRef.current.findIndex((lineItem) => {
            return lineItem.id == data.project_id
        })
        if (isLineOnScreen !== -1) {
            getLineItemProducts()
        }
    }
    // define socket event handler on first render
    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`)
        socket.on('realclosedupdates', (data) => {
            socketHandler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            socketHandler(data, 'bidAddtime')
        })
        // Bid Cancellation Event => Reload the product info
        socket.on('cancelbidemitted', function (data) {
            cancelBidHandler(data)
        })
        return () => {
            socket.off('realclosedupdates', (data) => {
                socketHandler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                socketHandler(data, 'bidAddtime')
            })
            socket.off('cancelbidemitted', function (data) {
                cancelBidHandler(data)
            })
            socket.disconnect()
        }
    }, [])

    useEffect(() => {
        let pageCount = Math.ceil(parseInt(totalProductCnt) / parseInt(pageLimit))
        setTotalPageCnt(pageCount)
    }, [totalProductCnt, pageLimit])

    useEffect(() => {
        if (firstLineItemLoad.current) firstLineItemLoad.current = false
        getLineItemProducts()
    }, [pageLimit, pageNum])

    useEffect(() => {
        if (product.id && !firstLineItemLoad.current) {
            getLineItemProducts()
        }
    }, [product.id])

    // set each line items view
    useEffect(() => {
        let lineItemsTemp = []
        if (lineItems.length == 0) {
            lineItemsTemp.push(
                <tr>
                    <td colSpan="5" className="text-center">
                        No line items available
                    </td>
                </tr>,
            )
        } else {
            let ref = {}
            lineItemsTemp = lineItems.map((item) => {
                ref[item.id] = {
                    next_bid: item.next_bid,
                    bid_increment: item.incrementAmt,
                }
                return (
                    <tr key={item.id}>
                        <td scope="row" data-title="">
                            {item.id}
                        </td>
                        <td>{item.description}</td>
                        <td
                            className="primeColor"
                            style={{ cursor: 'pointer' }}
                            onClick={toggleDrawer('right', true, {
                                id: item.id,
                            })}
                        >
                            {item.title}
                        </td>
                        <td>{item.category_id}</td>
                        <td>{item.qty}</td>
                        {product.bidtype != 'sealed' ? (
                            <td>
                                {item.currency} {item.currency_symbol}
                                {item.wprice}
                            </td>
                        ) : null}
                        {item.market_status == 'open' || item.isSocketUpdate ? (
                            <td>
                                <div className="lineItemAction">
                                    {item.bidPrice > 0 && item.market_status == 'open' ? (
                                        item.wprice >= item.rprice ? (
                                            <p>{phrase.reserve_price_is_met}</p>
                                        ) : (
                                            <p className="red">{phrase.reserve_price_is_not_met}</p>
                                        )
                                    ) : null}

                                    <BiddingItem
                                        product={item}
                                        phrases={phrase}
                                        wsprice={item.bidPrice}
                                        handleClose={() => {}}
                                    />
                                </div>
                            </td>
                        ) : null}

                        {product.bidtype != 'sealed' ? (
                            <td
                                dangerouslySetInnerHTML={{
                                    __html: item.bidtopstatus,
                                }}
                            ></td>
                        ) : null}
                    </tr>
                )
            })
            bulkBidRef.current = ref
            setLineItemsView(lineItemsTemp)
            setLineItemsReady(true)
        }
    }, [lineItems])

    useEffect(() => {
        //console.log('bulk bid line items: ', bulkBidLineItems)
        if (Object.keys(bulkBidLineItems).length > 0) {
            let table = []
            for (let item of bulkBidLineItems) {
                let tableRow = (
                    <>
                        <tr>
                            <td>{item.brand}</td>
                            <td>{item.product_name}</td>
                            <td>{item.category}</td>
                            <td>{item.qty}</td>
                            <td>
                                {item.wsprice} {product.currency}
                            </td>
                            {item.status}
                        </tr>
                    </>
                )
                table.push(tableRow)
            }
            // set the bulk bid line item table in the modal
            setBulkBidTable(table)
        }
    }, [bulkBidLineItems])

    // BULK BIDDING, once bulk bid item table is set, open the modal
    useEffect(() => {
        if (bulkBidTable.length > 0) {
            setBulkBidPopupOpen(true)
        }
    }, [bulkBidTable])
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            let lineDataIndex = product.linedata.findIndex((lindata) => {
                return lindata.id == data.id
            })
            let lineItemData = { ...product.linedata[lineDataIndex] }
            lineItemData.id = data.id
            setState({ ...state, [anchor]: open, data: lineItemData })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    const bidInstructionHandler = () => {
        setBidInstructionOpen(true)
    }
    const bidInstructionClose = () => {
        setBidInstructionOpen(false)
    }

    let downloadManifestFile = downloadFile
    const redirectToManifestFile = () => {
        window.location.href = `${global.site_url}/uploads/product_csv/${product.buyer_manifest_file}`
    }
    if (
        typeof product.download_complete_manifest !== 'undefined' &&
        product.download_complete_manifest != ''
    ) {
        downloadManifestFile = redirectToManifestFile
    }

    const openCsvBidFile = () => {
        document.getElementById('bid_csv').click()
    }
    const bulkBidPopupClose = () => {
        // re-initialize
        didBulkBid.current = false
        setBulkBidPopupOpen(false)
        setBulkBidLineItems([])
        setBulkBidTable([])
    }
    const uploadBulkBidding = (e) => {
        console.log('upload bulk bidding')
        var formData = new FormData()
        var bidFile = document.querySelector('#bid_csv')
        if (bidFile.files.length > 0) {
            formData.append('bid_csv', bidFile.files[0])
            formData.append('project_id', product.id)
            formData.append('currency', product.currency)
            apiCall('post', 'upload-bid-csv-lineitem', formData, 'formdata', 'product', {
                imagesession: 1,
            })
                .then((res) => {
                    console.log(res)
                    if (res.data.msgdata == 'success') {
                        console.log('SUCCESS')
                        let productCopy = { ...product }
                        productCopy.csvfile = res.data.csvfile
                        setProduct(productCopy)

                        var productBidArray = res.data.productBidArray
                        var bulkBids = []
                        for (let item of res.data.productBidArray) {
                            if (parseInt(item.wsprice) >= bulkBidRef.current[item.id].next_bid) {
                                item.status = (
                                    <td className="alert alert-warning">
                                        {phrase.waitingforconfirmation}
                                    </td>
                                )
                                item.bid_increment = bulkBidRef.current[item.id].bid_increment
                                item.csvfile = e.target.value
                                bulkBids.push(item)
                            }
                        }
                        setBulkBidLineItems(bulkBids)
                        // to re-upload again
                        e.target.value = null
                    }
                })
                .catch((err) => {
                    console.log('ERROR: ', err)
                    setAlert('Something wrong happend.. Please try again.', 'error')
                })
        }
    }
    const submitBulkBidding = () => {
        // console.log('SUBMITTING BULK BIDDING')
        // console.log(bulkBidLineItems)
        let bidArr = [...bulkBidLineItems]
        if (bidArr.length > 0) {
            for (let bid of bidArr) {
                var bidData = {
                    auctionType: 'lineitem',
                    bidType: product.bidtype,
                    lotType: '',
                    id: bid.id,
                    bid_increment: bid.bid_increment,
                    wsprice: bid.wsprice,
                    master_id: product.id,
                }
                // submit bid, response will be captured in socket event
                apiCall('post', 'bidConfirm', bidData, '', 'product')
            }
            // re-initialize the bulk bid array
            didBulkBid.current = true
        }
    }

    const contactPopupOpen = () => {
        setContactPopup(true)
    }
    const contactPopupClose = () => {
        setContactPopup(false)
    }
    const productDescClose = () => {
        setProductDescPopup(false)
    }
    const contactSeller = () => {
        let msg = document.getElementById('contactSellerMsg')
        if (msg.value != '') {
            contactPopupClose()
            let data = {}
            data.to_id = product.sellerid
            data.projectmsgpost = product.id
            data.message = msg.value
            data.from_id = user.id
            apiCall('post', 'savemessagefromview', data, '', 'messages')
                .then((res) => {
                    msg.value = ''
                    setAlert(phrase.message_successfully_sent, 'success')
                })
                .catch((err) => {
                    console.log(err)
                    setAlert('Something wrong happend.. Please try again.', 'error')
                })
        }
    }

    let categories = ''
    if (product) {
        for (let i in product.multiplecategoryshow) {
            if (i == product.multiplecategoryshow.length - 1) {
                // last index
                //categories += product.multiplecategoryshow[i]
                categories += phrase[product.multiplecategoryshow[i]]
            } else {
                //categories += product.multiplecategoryshow[i] + ', '
                categories += phrase[product.multiplecategoryshow[i]] + ', '
            }
        }
    }

    return (
        <>
            <div className="auctionView lineItemView container-fluid mt-2">
                <div className="customContainer">
                    <div className="d-flex justify-content-start">
                        <Button className="backBtn my-2" onClick={() => history.goBack()}>
                            <span className="material-icons">arrow_back</span>Back
                        </Button>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12 position-relative image-zoom-overlay">
                            {user.isBuyer && product.isclosed >= 0 ? (
                                <FavoriteCheckbox
                                    watchlisted={product.isWatchlisted}
                                    project_id={product.id}
                                />
                            ) : null}
                            <ImageGallery
                                items={images}
                                thumbnailPosition="bottom"
                                showNav={false}
                                showBullets={false}
                                showFullscreenButton={false}
                                showPlayButton={false}
                                autoPlay={true}
                                lazyLoad={true}
                                renderItem={(item) => (
                                    <div className="image-gallery-image text-center">
                                        <img
                                            src={item.original || item.src}
                                            alt={product.title}
                                            style={{
                                                cursor: 'zoom-in',
                                                maxWidth: '100%',
                                                maxHeight: '80vh',
                                                objectFit: 'contain',
                                            }}
                                            onClick={() => {
                                                setZoomImageIndex(images.indexOf(item))
                                                setZoomOpen(true)
                                                zoom.reset()
                                            }}
                                        />
                                    </div>
                                )}
                            />

                            {zoomOpen && (
                                <div
                                    style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100vw',
                                        height: '100vh',
                                        background: 'rgba(0,0,0,0.98)',
                                        zIndex: 9999,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        overflow: 'hidden',
                                    }}
                                    className="mobile-only"
                                    onClick={() => {
                                        setZoomOpen(false)
                                        zoom.reset()
                                    }}
                                    onWheel={zoom.handleWheel}
                                >
                                    <Button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            setZoomOpen(false)
                                            zoom.reset()
                                        }}
                                        style={{
                                            position: 'absolute',
                                            top: 15,
                                            right: 15,
                                            zIndex: 10001,
                                            minWidth: 50,
                                            width: 50,
                                            height: 50,
                                            background: 'rgb(255 255 255 / 12%)',
                                            color: '#ffffffff',
                                            borderRadius: '50%',
                                            fontSize: 28,
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        <span className="material-icons">close</span>
                                    </Button>
                                    <Button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            toggleFullscreen(e)
                                        }}
                                        style={{
                                            position: 'absolute',
                                            top: 15,
                                            right: 'clamp(15px, 15vh, 90px)',
                                            width: '50px',
                                            minWidth: '50px',
                                            height: '50px',
                                            borderRadius: '50%',
                                            background: 'rgb(255 255 255 / 12%)',
                                            color: '#ffffffff',
                                            fontSize: '28px',
                                            fontWeight: 'bold',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                                            zIndex: 10001,
                                        }}
                                    >
                                        <span className="material-icons">
                                            {isFullscreen ? 'fullscreen_exit' : 'fullscreen'}
                                        </span>
                                    </Button>
                                    <img
                                        src={
                                            images[zoomImageIndex]?.original ||
                                            images[zoomImageIndex]?.src
                                        }
                                        alt="Zoom"
                                        onClick={(e) => e.stopPropagation()}
                                        onWheel={zoom.handleWheel}
                                        onMouseDown={zoom.handleMouseDown}
                                        onMouseMove={zoom.handleMouseMove}
                                        onMouseUp={zoom.handleMouseUp}
                                        onMouseLeave={zoom.handleMouseUp}
                                        draggable={false}
                                        style={{
                                            maxWidth: '100vw',
                                            maxHeight: '100vh',
                                            objectFit: 'contain',
                                            transform: `translate(${zoom.position.x}px, ${zoom.position.y}px) scale(${zoom.zoom})`,
                                            transition: zoom.isDragging
                                                ? 'none'
                                                : 'transform 0.2s ease-out',
                                            cursor:
                                                zoom.zoom > 1
                                                    ? zoom.isDragging
                                                        ? 'grabbing'
                                                        : 'grab'
                                                    : 'zoom-out',
                                            userSelect: 'none',
                                        }}
                                    />
                                    {window.innerWidth > 768 && (
                                        <>
                                            <Button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setZoomImageIndex((i) =>
                                                        i === 0 ? images.length - 1 : i - 1,
                                                    )
                                                    zoom.reset()
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    left: 20,
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    zIndex: 10000,
                                                    background: 'rgba(255, 255, 255, 0)',
                                                    color: '#ffffffff',
                                                    borderRadius: '50%',
                                                    width: 60,
                                                    minWidth: 60,
                                                    height: 60,
                                                    fontSize: 36,
                                                }}
                                            >
                                                <span className="material-icons">
                                                    keyboard_backspace
                                                </span>
                                            </Button>
                                            <Button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setZoomImageIndex((i) =>
                                                        i === images.length - 1 ? 0 : i + 1,
                                                    )
                                                    zoom.reset()
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    right: 20,
                                                    top: '50%',
                                                    transform: 'translateY(-50%) rotate(180deg)',
                                                    zIndex: 10000,
                                                    background: 'rgba(255, 255, 255, 0)',
                                                    color: '#ffffffff',
                                                    borderRadius: '50%',
                                                    minWidth: 60,
                                                    width: 60,
                                                    height: 60,
                                                    fontSize: 36,
                                                }}
                                            >
                                                <span className="material-icons">
                                                    keyboard_backspace
                                                </span>
                                            </Button>
                                        </>
                                    )}
                                    {window.innerWidth <= 768 && (
                                        <div
                                            className="mobile-only"
                                            style={{
                                                position: 'absolute',
                                                bottom: 0,
                                                width: '100%',
                                                height: 100,
                                                background:
                                                    'linear-gradient(transparent, rgba(0,0,0,0.8))',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: 40,
                                                paddingBottom: 'env(safe-area-inset-bottom)',
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <Button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setZoomImageIndex((i) =>
                                                        i === 0 ? images.length - 1 : i - 1,
                                                    )
                                                    zoom.reset()
                                                    if (navigator.vibrate) navigator.vibrate(30)
                                                }}
                                                style={{
                                                    width: 70,
                                                    height: 70,
                                                    borderRadius: '50%',
                                                    background: 'white',
                                                    color: 'black',
                                                    fontSize: 40,
                                                }}
                                            >
                                                <span className="material-icons">
                                                    keyboard_backspace
                                                </span>
                                            </Button>

                                            <div style={{ color: 'white', fontSize: 16 }}>
                                                {zoomImageIndex + 1} / {images.length}
                                            </div>

                                            <Button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setZoomImageIndex((i) =>
                                                        i === images.length - 1 ? 0 : i + 1,
                                                    )
                                                    zoom.reset()
                                                    if (navigator.vibrate) navigator.vibrate(30)
                                                }}
                                                style={{
                                                    width: 70,
                                                    height: 70,
                                                    borderRadius: '50%',
                                                    background: 'white',
                                                    transform: 'rotate(180deg)',
                                                    color: 'black',
                                                    fontSize: 40,
                                                }}
                                            >
                                                <span className="material-icons">
                                                    keyboard_backspace
                                                </span>
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="col-lg-8 col-md-6 col-12">
                            <div className="lineItemTimerCnt primeColor">
                                <Timer
                                    date_added={product.date_added}
                                    date_closed={product.date_closed}
                                    withText={0}
                                ></Timer>
                                <br />
                                <h6>{dateFormatFront(product.date_closed)}</h6>
                            </div>
                            <h2 className="pvTitle">{product.title}</h2>

                            <div className="lineItemInfo">
                                <div>
                                    <div className="pvGrid">
                                        <div className="pvGrid">
                                            <label> {phrase.no_of_items}</label>
                                            <span>{product.qty}</span>
                                        </div>
                                        <div className="pvGrid">
                                            <label>{phrase.condition}</label>
                                            <span>
                                                {phrase[product.condition]
                                                    ? phrase[product.condition]
                                                    : product.condition}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="pvGrid">
                                        <div className="pvGrid">
                                            <label>{phrase.lot_size}</label>
                                            <span>
                                                {' '}
                                                {phrase[product.lottype]} {phrase.lot}
                                            </span>
                                        </div>
                                        <div className="pvGrid">
                                            <label>{phrase.category}</label>
                                            <span>{categories}</span>
                                        </div>
                                    </div>

                                    <div className="pvGrid">
                                        <div className="pvGrid">
                                            <label> {phrase.auction_type} </label>
                                            <span> {phrase.auction_type} </span>
                                        </div>
                                        <div className="pvGrid">
                                            <label> {phrase.location} </label>
                                            <span> {product.city} </span>
                                        </div>
                                    </div>

                                    <div className="pvDesc">
                                        <label>{phrase.description}</label>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    product.desc_proc.length > 200
                                                        ? product.desc_proc.substring(0, 200)
                                                        : product.desc_proc,
                                            }}
                                        ></p>
                                        {product.desc_proc.length > 200 ? (
                                            <a
                                                className="font-25"
                                                onClick={() => setProductDescPopup(true)}
                                            >
                                                {phrase.view_more}
                                            </a>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="scrollDown">
                                    <div className="ndCTA">
                                        <Button
                                            onClick={() =>
                                                document
                                                    .getElementById('productView')
                                                    .scrollIntoView({ behavior: 'smooth' })
                                            }
                                        >
                                            {phrase.scroll_to_bid}
                                        </Button>
                                        <div className="arrow">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3 mb-2"></div>
                                <div>
                                    <Button
                                        className="contactSeller"
                                        onClick={contactPopupOpen}
                                        disabled={user.isBuyer ? false : true}
                                    >
                                        <span className="material-icons">chat</span>
                                        <span> {phrase.contact_seller} </span>
                                    </Button>
                                </div>
                                <Popup
                                    open={contactPopup}
                                    handleClose={contactPopupClose}
                                    modaltitle={phrase.send_message}
                                    footer={
                                        <>
                                            <PrimaryButton
                                                label={phrase.send}
                                                onClick={contactSeller}
                                            />
                                            <SecondaryButton
                                                label={phrase.cancel}
                                                onClick={contactPopupClose}
                                            />
                                        </>
                                    }
                                >
                                    <div className="row text-left">
                                        <div className="col-md-2">
                                            <label>{phrase.title}</label>
                                        </div>
                                        <div className="col-md-8">
                                            <label>{product.title}</label>
                                        </div>
                                    </div>
                                    <div className="row text-left">
                                        <div className="col-md-2">
                                            <label>{phrase.message}</label>
                                        </div>
                                        <div className="col-md-8">
                                            <textarea
                                                className="form-control"
                                                id="contactSellerMsg"
                                                rows="4"
                                                placeholder={phrase.enter_your_message}
                                            ></textarea>
                                        </div>
                                    </div>
                                </Popup>
                            </div>
                        </div>
                        <div className="col-12 lotDetails" id="productView">
                            {product.currencyexist ? <CurrencyConverter product={product} /> : null}
                            <div className="lineItemMiscActions d-flex justify-content-end align-items-center">
                                <SecondaryButton
                                    btnSize="small"
                                    label={[
                                        <span className="material-icons">info</span>,
                                        phrase.bidding_instruction,
                                    ]}
                                    onClick={bidInstructionHandler}
                                />
                                {isAuthenticated ? (
                                    <>
                                        <SecondaryButton
                                            btnSize="small"
                                            label={[
                                                <span className="material-icons">
                                                    cloud_download
                                                </span>,
                                                phrase.download_complete_manfiest,
                                            ]}
                                            onClick={downloadManifestFile}
                                        />
                                        {product.isclosed >= 0 ? (
                                            <SecondaryButton
                                                btnSize="small"
                                                label={[
                                                    <span className="material-icons">
                                                        cloud_upload
                                                    </span>,
                                                    phrase.upload_bulk_bidding,
                                                ]}
                                                onClick={openCsvBidFile}
                                                disabled={user.isBuyer ? false : true}
                                            />
                                        ) : null}

                                        <input
                                            type="file"
                                            id="bid_csv"
                                            accept=".xls,.xlsx"
                                            onChange={(e) => uploadBulkBidding(e)}
                                            hidden
                                        />
                                    </>
                                ) : null}
                            </div>
                            <h2>{phrase.line_item_bidding}</h2>
                            <div className="customTabs">
                                <AppBar position="static">
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        aria-label="Line Item Auctions"
                                        indicatorColor="primary"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                    >
                                        <Tab label="Products Description" {...a11yProps(0)} />
                                        <Tab label="Condition" {...a11yProps(1)} />
                                        <Tab label="FAQ" {...a11yProps(2)} />
                                        <Tab label="Shipping" {...a11yProps(3)} />
                                        <Tab label="Payment Note" {...a11yProps(4)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={value} index={0}>
                                    <div className="lotDataSort mt-4 d-flex justify-content-between align-items-center flex-wrap">
                                        <h6 className="lotCount">
                                            {phrase.showing} {pageDescription} {phrase.of}{' '}
                                            {totalProductCnt} {phrase.lots}
                                        </h6>
                                        <CustomSelect
                                            size="small"
                                            label="Show Results"
                                            onChange={changePageLimit}
                                            value={pageLimit}
                                        >
                                            <MenuItem value={10}>10</MenuItem>
                                            <MenuItem value={25}>25</MenuItem>
                                            <MenuItem value={50}>50</MenuItem>
                                        </CustomSelect>
                                    </div>

                                    {lineItemsReady ? (
                                        <table className="table mobileTable laTable table-striped">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">{phrase.sublot_id}</th>
                                                    <th scope="col">{phrase.brand}</th>
                                                    <th scope="col">{phrase.product_name}</th>
                                                    <th scope="col">{phrase.category}</th>
                                                    <th scope="col">{phrase.qty}</th>
                                                    {product.bidtype != 'sealed' ? (
                                                        <th scope="col">{phrase.current_bid}</th>
                                                    ) : null}

                                                    <th scope="col">{phrase.action}</th>

                                                    {product.bidtype != 'sealed' ? (
                                                        <th scope="col">{phrase.status}</th>
                                                    ) : (
                                                        <th scope="col"></th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody className="mtInner">{lineItemsView}</tbody>
                                        </table>
                                    ) : (
                                        <Loader />
                                    )}
                                    <div className="d-flex justify-content-center mb-5">
                                        <Pagination
                                            count={totalPageCnt}
                                            onChange={changePageHandler}
                                        ></Pagination>
                                    </div>
                                    {isAuthenticated ? (
                                        <div style={{ textAlign: 'center' }}>
                                            <PrimaryButton
                                                onClick={downloadManifestFile}
                                                width="40%"
                                            >
                                                <span
                                                    className="material-icons"
                                                    style={{ marginRight: '3px' }}
                                                >
                                                    cloud_download
                                                </span>{' '}
                                                {phrase.download_complete_manfiest}
                                            </PrimaryButton>
                                        </div>
                                    ) : null}
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    {ReactHtmlParser(
                                        product?.desc_condition?.replace(/<br\s*\/?>/gi, ''),
                                    )}
                                </TabPanel>
                                <TabPanel
                                    value={value}
                                    index={2}
                                    html={product.faqContent}
                                ></TabPanel>
                                <TabPanel value={value} index={3}>
                                    {product.buyership == 1
                                        ? phrase.productview_1
                                        : product.shipping_service}
                                </TabPanel>
                                <TabPanel value={value} index={4}>
                                    {phrase.payment_note_details}
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-12 assuranceCnt">
                        <div className="customContainer ">
                            <div className="col-lg-8 col-12">
                                <div className="assuranceCard d-flex justify-content-between">
                                    <span className="material-icons">verified</span>
                                    <div>
                                        <h2>{phrase.buy_with_confidence}</h2>
                                        <p>{phrase.productview_2}</p>
                                        <p>{phrase.productview_3}</p>
                                        <p>{phrase.productview_4}</p>
                                        <span className="leaf">
                                            <span className="material-icons">eco</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
            <Drawer
                className="rightDrawer"
                anchor={'right'}
                open={state['right']}
                onClose={toggleDrawer('right', false)}
            >
                <LineItemDetails data={state['data']} close={toggleDrawer('right', false)} />
            </Drawer>
            {/* /Bidding Instruction Popup*/}
            <Popup
                open={bidInstructionOpen}
                modaltitle={phrase.bidding_instruction}
                handleClose={bidInstructionClose}
                footer={<SecondaryButton label={phrase.close} onClick={bidInstructionClose} />}
            >
                <p dangerouslySetInnerHTML={{ __html: product.bidInstruction.for_english }} />
            </Popup>
            {/* Bulk Bidding Popup */}
            <Popup
                open={bulkBidPopupOpen}
                handleClose={bulkBidPopupClose}
                modaltitle={phrase.bid_confirmation}
                footer={
                    didBulkBid.current ? (
                        <PrimaryButton label={phrase.close} onClick={bulkBidPopupClose} />
                    ) : (
                        <>
                            {' '}
                            <PrimaryButton label={phrase.submit} onClick={submitBulkBidding} />
                            <SecondaryButton
                                label={phrase.cancel}
                                onClick={bulkBidPopupClose}
                            />{' '}
                        </>
                    )
                }
            >
                <div className="row ml-2 mr-2">
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>{phrase.brand}</th>
                                <th>{phrase.product_name}</th>
                                <th>{phrase.category}</th>
                                <th>{phrase.qty}</th>
                                <th>{phrase.amount}</th>
                                <th>{phrase.status}</th>
                            </tr>
                        </thead>
                        <tbody>{bulkBidTable}</tbody>
                    </table>
                </div>
            </Popup>

            {/* Long Product Description Modal*/}
            <Popup
                open={productDescPopup}
                modaltitle={phrase.description}
                handleClose={productDescClose}
                footer={<SecondaryButton label={phrase.close} onClick={productDescClose} />}
            >
                <div
                    style={{ textAlign: 'left' }}
                    dangerouslySetInnerHTML={{
                        __html: product.desc_proc,
                    }}
                ></div>
            </Popup>

            {showDwBidStatus ? (
                <div className="dwBidStatus">
                    <a onClick={downloadBidStatus}>{phrase.download_bid_status}</a>
                </div>
            ) : null}
        </>
    )
}

export default LineItemAuction
